import script from "./ButtonNeutralSecondary.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonNeutralSecondary.vue?vue&type=script&setup=true&lang=js"

import "./ButtonNeutralSecondary.vue?vue&type=style&index=0&id=0a6526ba&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a6526ba"]])

export default __exports__